import PropTypes from "prop-types";
import Title from "../../../../components/Title/component";
import RelatedStory from "./components/RelatedStory/component";
import RelatedExternal from "./components/RelatedExternal/component";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";
import featureAttr from "../../../../utils/featureAttr";

/**
 * Related links for the detail page.
 *
 * Injects object arrays of related stories, leftover media, leftover photogallery, similar links or link bundle
 *
 * @param {Object} props The component props
 * @returns {React.Component} The RelatedLinks component
 */

export function RelatedLinks({
    heading = "Related Stories",
    intlinks,
    relatedItems,
    eplinks,
    externalLinks,
}) {
    const links = relatedItems || intlinks;
    const relatedStory =
        links?.length > 0 ? <RelatedStory links={links} /> : null;
    const relatedEpisode =
        eplinks?.length > 0 ? <RelatedStory links={eplinks} /> : null;
    const relatedExternal =
        externalLinks?.length > 0 ? (
            <RelatedExternal links={externalLinks} />
        ) : null;

    if (!relatedExternal && !relatedEpisode && !relatedStory) return null;

    return (
        <div
            className="relatedlinks"
            data-testid="relatedlinks"
            {...featureAttr({
                name: "link",
                instance: "related-link",
            })}
        >
            <Title level="h2">{heading}</Title>
            <ul className="relatedList">
                {relatedStory}
                {relatedEpisode}
                {relatedExternal}
            </ul>
        </div>
    );
}

RelatedLinks.propTypes = {
    relatedItems: PropTypes.array,
    intlinks: PropTypes.array,
    eplinks: PropTypes.array,
    externalLinks: PropTypes.array,
    heading: PropTypes.string,
};

RelatedLinks.defaultProps = {
    relatedItems: null,
    heading: "Related Stories",
};

const SafeRelatedLinks = withSuspensefulErrorBoundary(RelatedLinks);

export default SafeRelatedLinks;
